import React, { useCallback } from 'react';
import styles from './MaintenanceScreen.module.css';
import useTranslation from '@hooks/useTranslation';
import KemuLogo from '@src/assets/img/kemu-logo.png';
import { MailOutlined, DiscordOutlined } from '@ant-design/icons';

/**
 * MaintenanceScreen renders a simple maintenance message while the site is unavailable.
 * Arguments: none
 * Returns: JSX.Element
 */
const MaintenanceScreen = (): React.JSX.Element => {
  const t = useTranslation();

  /**
   * handleOpenDiscord opens our Discord channel in a new tab.
   * Arguments: none
   * Returns: void
   */
  const handleOpenDiscord = (): void => {
    // Reuse same pattern as in main menu: invite code from translations
    window.open(`https://discord.gg/${t('Menu.Discord.InviteCode')}`, '_blank');
  };

  const onEmailClick = useCallback(() => {
    window.location.href = 'mailto:support@kemu.io';
  }, []);

  return (
    <div className={styles.Container}>
      <div className={styles.Icon}>
        <img src={KemuLogo} alt="Kemu Logo" />
      </div>
      <h1 className={styles.Title}>{t('Maintenance.Title')}</h1>
      <p className={styles.Subtitle}>{t('Maintenance.Subtitle')}</p>
      <div className={styles.Footer}>
        <div className={styles.HelpText}>{t('Maintenance.Footer.HelpText')}</div>
        <div className={styles.Actions}>
          <div className={styles.Card} onClick={onEmailClick} role="button" tabIndex={0} onKeyPress={onEmailClick}>
            <MailOutlined className={styles.CardIcon} />
            <span className={styles.CardText}>support@kemu.io</span>
          </div>
          <div className={styles.Card} onClick={handleOpenDiscord} role="button" tabIndex={0}>
            <DiscordOutlined className={styles.CardIcon} />
            <span className={styles.CardText}>Discord</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;


